// extracted by mini-css-extract-plugin
module.exports = {"tabsWrapper":"index_tabsWrapper__2GQ-C"};